import axios from 'axios'
import config from '@/config'

const actions = {
  HOUSE_INFO({rootGetters}, houseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'house/info/' + houseId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  SAVE_HOUSE({rootGetters}, house) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'house/save', house, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_HOUSE_DETAILS({rootGetters}, houseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'house/details/' + houseId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
